import ApplicationController from "./application_controller"; 
import { formatText } from "../utils/text_formater";

export default class extends ApplicationController {

    static targets = ["hm0_output"];

    connect() {
        console.log("Entretiens recrutements JS en cours ...");
        super.connect();

        var self = this;

        console.log("current app: " + this.current_app)
        if ($("#search").length && $("#quick_sort").length) {
            //on est sur la vue list
            //this.show_edition_multiple();
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });

            this.handleSidebarScroll("entretiens_recrutement_");


        }
    }


update_commentaires(event) {
  event.preventDefault();
  const btn = event.currentTarget;

  const textareaId = btn.dataset.textareaId;
  const textarea   = document.getElementById(textareaId);
  const value      = textarea ? textarea.value : "";

 
  const len = new Blob([value]).size;   // taille en octets réelle
  const maxLen = parseInt(btn.dataset.maxLength || "65535", 10);
 
  if (maxLen > 0 && len > maxLen) {
    const over = len - maxLen;
 
    $("#fx-conteneur-error").remove();
    const $flash = $(`
      <div id="fx-conteneur-error" class="fx-flash-top-right fx-flash-error fx-flash-message"
           role="alert" aria-live="polite"
           data-controller="flash"
           data-flash-target="container"
           data-action="mouseenter->flash#mouseenter mouseleave->flash#mouseleave">
        <button class="fx-flash-close-button" data-action="flash#dismissManually" aria-label="Fermer">&times;</button>
        <p class="fx-flash-explanation">Merci de corriger les erreurs suivantes :</p>
        <div class="fx-inline-message">
          <span class="fx-chip"></span>
          <span>Le commentaire dépasse la limite du nombre de carractèrere autorisée (<strong>${maxLen}</strong> caractères). Vous avez <strong>${len}</strong> caractères (<strong>+${over}</strong>).</span>
        </div>
        <div class="fx-progress-bar" data-flash-target="progressBar"></div>
      </div>
    `);
    $("body").prepend($flash);
    setTimeout(() => $flash.fadeOut(500, () => $flash.remove()), 5000);

  if (textareaId) {
    const taC = document.getElementById(textareaId);
    if (taC) {
      this.toggleClassName(taC,"bg-required")
      setTimeout(() => { this.toggleClassName(taC,"bg-required")}, 3000);
    }
  }
 
    return;
  }

  // Sinon, on peut envoyer
  if (!this.isActionCableConnectionOpen()) {
    btn.style.backgroundColor = "#FF8B8B";
    btn.style.boxShadow = "0px 1px 10px red";
    return;
  }

  btn.dataset.newValue = value;
  btn.disabled = true;

  this.stimulate("Entretiens#update_commentaires", btn, { value })
    .finally(() => { btn.disabled = false; });
}


updateCommentairesHalted(element) {
  console.log("HALTED");
  element.style.backgroundColor = "#FF8B8B";
  element.style.boxShadow = "0px 1px 10px red";
}
 
updateCommentairesError(element, reflex, error, reflexId) {
 


  // 1) Highlight rouge sur la textareaId concernée (3s) 
  const textareaId           = element.dataset.textareaId;

  if (textareaId) {
    const taC = document.getElementById(textareaId);
    if (taC) {
      this.toggleClassName(taC,"bg-required")
      setTimeout(() => { this.toggleClassName(taC,"bg-required")}, 3000);
    }
  }
 
  $("#fx-conteneur-error").remove();

  // message par défaut (tu peux aussi passer element.dataset.errorMessage)
  const message =
    element?.serverMessage?.body ||
    "La sauvegarde a échoué. Veuillez réessayer.";

  const $flash = $(`
    <div id="fx-conteneur-error" class="fx-flash-top-right fx-flash-error fx-flash-message"
         role="alert" aria-live="polite"
         data-controller="flash"
         data-flash-target="container"
         data-action="mouseenter->flash#mouseenter mouseleave->flash#mouseleave">
      <button class="fx-flash-close-button" data-action="flash#dismissManually" aria-label="Fermer">&times;</button>
      <p class="fx-flash-explanation">Merci de corriger les erreurs suivantes :</p>
      <div class="fx-inline-message">
        <span class="fx-chip"></span><span>${message}</span>
      </div>
      <div class="fx-progress-bar" data-flash-target="progressBar"></div>
    </div>
  `);

  $("body").prepend($flash);

  
  setTimeout(() => {
    $flash.fadeOut(500, () => $flash.remove());
  }, 5000);

 
}

updateCommentairesSuccess(element) {
  // fermer la fancybox
  try {
    if (window.Fancybox && typeof Fancybox.close === "function") {
      Fancybox.close();
    } else if (window.jQuery && window.jQuery.fancybox) {
      window.jQuery.fancybox.close();
    }
  } catch (_) {}

 
  const newValue             = element.dataset.newValue || "";
  const previewId            = element.dataset.previewId;
  const fullContentId        = element.dataset.fullContentId;
  const tooltipCommentaireId = element.dataset.tooltipCommentaireId;
  const textareaId           = element.dataset.textareaId;
  const tdContainerId        = element.dataset.tdContainerId;

  // 1) Aperçu tronqué (cellule)
  if (previewId) {
    const preview = document.getElementById(previewId);
    if (preview) {
      preview.textContent = newValue;
      preview.title = newValue;
    }
  }

  // 2) Contenu “Voir” (lecture)
  if (fullContentId) {
    const fullEl = document.getElementById(fullContentId);
    if (fullEl) fullEl.innerHTML = formatText(newValue); 
  }

  // 3) Tooltip caché
  if (tooltipCommentaireId) {
    const ttEl = document.getElementById(tooltipCommentaireId);
    if (ttEl) ttEl.textContent = newValue;
  }

  // 4) Textarea (édition)
  if (textareaId) {
    const ta = document.getElementById(textareaId);
    if (ta) ta.value = newValue;
  }
  // 5) Flash success
  $("#fx-conteneur-notice").remove();

  const message =
    element?.dataset?.successMessage || "Commentaire modifié avec succès";

  const $flash = $(`
    <div id="fx-conteneur-notice" class="fx-flash-top-right fx-flash-success fx-flash-message"
         role="alert" aria-live="polite"
         data-controller="flash"
         data-flash-target="container"
         data-action="mouseenter->flash#mouseenter mouseleave->flash#mouseleave">
      <button class="fx-flash-close-button" data-action="flash#dismissManually" aria-label="Fermer">&times;</button>
      <div class="fx-inline-message">
        <span>${message}</span>
      </div>
      <div class="fx-progress-bar" data-flash-target="progressBar"></div>
    </div>
  `);

  $("body").append($flash);
  
  // 6) Feedback visuel sur la cellule (3s)
  if (tdContainerId) {
    const tdC = document.getElementById(tdContainerId);
    if (tdC) {
      tdC.style.backgroundColor = "#ffb0004d";
      setTimeout(() => { tdC.style.backgroundColor = ""; }, 3000);
    }
  }
  setTimeout(() => {
    $flash.fadeOut(500, () => $flash.remove());
  }, 5000);



  // cleanup local
  delete element.dataset.newValue;
}
 
afterUpdateCommentaires(_element) { /* no-op */ }


    openNav() {
        return new Promise((resolve, reject) => {
            document.getElementById("mySidebar").style.width = "366.8px";
            document.getElementById("main").style.marginRight = "366.8px";
            resolve(true);
        });
    }

    closeNav() {
        return new Promise((resolve, reject) => {
            document.getElementById("mySidebar").style.width = "0px";
            document.getElementById("main").style.marginRight = "0px";
            resolve(true);
        });
    }

    get current_app() {
        return this.data.get("app");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }

}
